import React from 'react';
import { useLocation } from 'react-router-dom';

/** Subtle fade-in when the route pathname changes (no blocking loader). */
export default function RouteTransition({ children }) {
  const location = useLocation();
  return (
    <div key={location.pathname} className="art-route-enter min-h-full w-full">
      {children}
    </div>
  );
}
